import { render, staticRenderFns } from "./AlterarValorDialog.vue?vue&type=template&id=53662dfc&"
import script from "./AlterarValorDialog.vue?vue&type=script&lang=js&"
export * from "./AlterarValorDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports